'use strict';
import { sidebar as AdminSidebarLegacy } from 'App/babel/components/LegacyAdmin/sidebar';

angular.module('upDirectives').directive('upAdminSidebarRoot', [
	'$translate',
	'$upModal',
	'EditorCk',
	'$datepicker',
	'$timepicker',
	'$rootScope',
	'AppService',
	'FeatureHelper',
	'avatarService',
	function (
		$translate,
		$upModal,
		EditorCk,
		$datepicker,
		$timepicker,
		$rootScope,
		AppService,
		FeatureHelper,
		avatarService
	) {
		return {
			restrict: 'A',
			template: '<div></div>',
			replace: true,
			link: function ($scope, $element, $attr) {
				var firstElement = $element[0];
				var renderTimeout;
				var rootData;
				var tools = {
					$translate: $translate.instant,
					$upModal: $upModal,
					EditorCk: EditorCk,
					$datepicker: $datepicker,
					$timepicker: $timepicker,
					$rootScope: $rootScope,
					AppService: AppService,
					FeatureHelper: FeatureHelper,
					avatarService: avatarService
				};

				var render = function () {
					if (renderTimeout) {
						clearTimeout(renderTimeout);
					}
					renderTimeout = setTimeout(function () {
						if (!firstElement) {
							return;
						}

						_getOrCreateRoot(firstElement).render(
							React.createElement(AdminSidebarLegacy, {
								// Data and stuff
								rootData: Object.assign({}, rootData),
								tools: tools
							})
						);
					}, 20);
				};

				$scope.$on('$destroy', function () {
					_unmountRoot(firstElement);
					firstElement = undefined;
				});

				$scope.$watch(
					$attr.upAdminSidebarRoot,
					function (data) {
						rootData = data;
						render();
					},
					true
				);

				render();
			}
		};
	}
]);
